// extracted by mini-css-extract-plugin
var _1 = "HCuf8";
export { _1 as "base" }
